import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import { OtaOverviewState } from './useOtaOverview';

/** The four figures at the top: coverage, gateways to update, running updates, firmware count. */
export const OtaStatsGrid: React.FC<{ figures: OtaOverviewState['figures'] }> = ({ figures }) => {
  const { t } = useI18n();
  return (
    <div className="stats-grid">
      <div className="stat-card success">
        <div className="stat-icon">📊</div>
        <div className="stat-content">
          <div className="stat-value">{figures.coveragePercent}%</div>
          <div className="stat-label">{t('otaUpdates.updateCoverage')}</div>
        </div>
        <div className="stat-meta">{t('otaUpdates.coverageMeta', { upToDate: figures.upToDate, total: figures.totalDevices })}</div>
      </div>

      <div className="stat-card warning">
        <div className="stat-icon">⚠️</div>
        <div className="stat-content">
          <div className="stat-value">{figures.needingUpdate}</div>
          <div className="stat-label">{t('otaUpdates.needsUpdate')}</div>
        </div>
        <div className="stat-meta">{t('otaUpdates.needsUpdateMeta')}</div>
      </div>

      <div className="stat-card primary">
        <div className="stat-icon">🔄</div>
        <div className="stat-content">
          <div className="stat-value">{figures.inProgress}</div>
          <div className="stat-label">{t('otaUpdates.inProgress')}</div>
        </div>
        <div className="stat-meta">{t('otaUpdates.inProgressMeta')}</div>
      </div>

      <div className="stat-card secondary">
        <div className="stat-icon">📦</div>
        <div className="stat-content">
          <div className="stat-value">{figures.firmwareCount}</div>
          <div className="stat-label">{t('otaUpdates.firmwareVersions')}</div>
        </div>
        <div className="stat-meta">{t('otaUpdates.firmwareMeta')}</div>
      </div>
    </div>
  );
};
